var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLightningBolt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F9A825",
  d: "M8.97 7.25h2.613c.312 0 .593.194.682.485a.72.72 0 0 1-.187.83l-6 5.25a.752.752 0 0 1-1.184-.86L6.697 8.75H4.062a.752.752 0 0 1-.473-1.315l6-5.25a.75.75 0 0 1 1.183.86z"
})));
export default SvgLightningBolt;